export default __webpack_public_path__ + "static/media/img-39-alwin.e37e4d43.jpg";